import { Component, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationMessage, ConfirmationResult } from '@shared/_constants';
import { Subject} from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { DialogService } from '@services/dialog.service';
@Component({
  selector: 'app-nonai-version-notice',
  templateUrl: './nonai-version-notice.component.html',
  styleUrls: ['./nonai-version-notice.component.css']
})
export class NonAiVersionNoticeComponent implements OnDestroy {
  private destroy$ = new Subject();

  ngOnDestroy(): void {
    this.destroy$.next('');
  }

  constructor(
    private activeModal: NgbActiveModal,
    private store: Store<AppState>,
    private dialogService: DialogService,
  ) {
  }

  public async goToGenAIVersion() {
    const confirmationResult = await this.dialogService.confirm(
      'Please Confirm',
      ConfirmationMessage.WelcomeScreenConfirmationMessage,
      'Back',
      'Acknowledge',
    );
    if (confirmationResult === ConfirmationResult.yes) this.activeModal.close(ConfirmationResult.yes);
    if (confirmationResult === ConfirmationResult.no) {
      this.activeModal.close(ConfirmationResult.no);
    }
  }

  public async proceed() {
    this.activeModal.close(ConfirmationResult.yes);
  }

  public async close() {
    this.activeModal.close(ConfirmationResult.no);
  }
  public async acknowledge() {
    this.activeModal.close(ConfirmationResult.yes);
  }
  scroll(element) {
    if (element != null) {
      element.scrollIntoView();
    }
  }
}
